import React from 'react';
import fetch from '../../core/fetch';
import { wk_app } from '../../config';

class LoginPZ extends React.Component {

  componentDidMount() {
     if (!props.wkLogin) {
      window.location.replace(`${window.location.origin}/logowanieSAML?redirectUrl=${window.location.href}`);
    }
  }

  render() {
    return <div>Wczytywanie...</div>;
  }
}


export default LoginPZ;



// WEBPACK FOOTER //
// src/routes/eservices/loginPZ.js